import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FormQuestion from "./FormQuestion";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import { sectionHasChanged, sectionRead } from "../../redux/humanResources/humanResourcesActions";
import { throwErrorMessage } from "../../lib/error_helper";
import { getCurrentFunctionName } from "../../performanceModeManager";
import "./FormSection.css";
import { saveQuestions } from "../../redux/humanResources/humanResourcesEditionActions";
import { clone } from "../../utils";
import { canUpdateForm } from "../../redux/humanResources/humanResourcesStatusActions";

const styles = (theme) => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    italic: {
        fontSize: theme.typography.pxToRem(13),
        flexBasis: "33.33%",
        flexShrink: 0,
        fontStyle: "italic",
        paddingTop: 0,
    },
    AccordionSummaryContent: {
        content: {
            margin: 3,
        },
    },
});

class FormSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: this.props.expandedSectionId === this.props.currentSectionId,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let expanded = nextProps.expandedSectionId === nextProps.currentSectionId;

        if (prevState.expanded === expanded) return prevState;

        return {
            expanded,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if ((nextProps.expandedSectionId === nextProps.currentSectionId) !== this.state.expanded) return true;

        if (this.props.currentSectionId !== nextProps.currentSectionId) return true;

        let nextSectionValues = nextProps.sections.find((bv) => bv.id === nextProps.currentSectionId);

        let actualSectionValues = this.props.sections.find((bv) => bv.id === this.props.currentSectionId);

        let isNextSectionRead = sectionRead(nextSectionValues);
        let isCurrentSectionRead = sectionRead(actualSectionValues);

        if (isNextSectionRead !== isCurrentSectionRead) return true;

        if (!nextState.expanded) return false;

        if (!nextSectionValues || !actualSectionValues) {
            console.error("Valeurs introuvables");
            return null;
        }

        try {
            return sectionHasChanged(nextSectionValues, actualSectionValues);
        } catch (err) {
            return true;
        }
    }

    onSectionHeaderClick = () => {
        this.props.onClick(this.props.currentSectionId);
    };

    responseValueChange(metaQuestion) {
        let sectionId = this.props.currentSectionId;
        this.props.responseValueChange(sectionId, metaQuestion);

        this.forceUpdate();
    }

    getSectionClasses() {
        let classes = "";

        if (this.props.expandedSectionId === this.props.currentSectionId) classes = classes.concat("expanded-section");

        return classes;
    }

    getClasses() {
        let classes = "section-header without-side-padding";

        if (this.props.expandedSectionId === this.props.currentSectionId) classes = classes.concat(" expanded-section");

        return classes;
    }

    saveSection(sectionId) {
        let sections = clone(this.props.sections);
        let section = sections.find((bv) => bv.id === sectionId);

        section.questions.forEach((q) => {
            q.response_lines.forEach((rl) => (rl.state = "done"));
            q.state = "done";
        });

        this.props.saveQuestions(this.props.form, sections, section.questions, this.props.activeUser);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        const { classes } = this.props;
        let questionsElements = [];
        let section = this.props.sections.find((bv) => bv.id === this.props.currentSectionId);

        if (this.props.expandedSectionId) {
            if (!section) {
                console.error("Valeurs introuvables");
                return null;
            }

            section.questions
                .sort((mq) => mq.sequence)
                .forEach((metaQuestion) => {
                    let required = metaQuestion.is_require_answer;

                    let index = metaQuestion.id;

                    questionsElements.push(
                        <FormQuestion
                            key={index}
                            id={[this.props.id.toString(), index].join("-")}
                            responseValueChange={this.responseValueChange.bind(this)}
                            metaQuestion={metaQuestion}
                            sectionId={section.id}
                            form={this.props.form}
                            required={required}
                            section={section}
                            save={this.props.save}
                        />
                    );
                });
        }

        let expandedElement = null;

        if (this.props.expandedSectionId !== this.props.currentSectionId)
            expandedElement = (
                <IconButton color="inherit" onClick={this.onSectionHeaderClick.bind(this)} aria-label="Étendre">
                    <ExpandMoreIcon />
                </IconButton>
            );
        else
            expandedElement = (
                <IconButton color="inherit" onClick={this.onSectionHeaderClick.bind(this)} aria-label="Réduire">
                    <ExpandLessIcon />
                </IconButton>
            );

        return (
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                ref={(panel) => (this.panel = panel)}
                style={{ overflowAnchor: this.state.expanded ? "auto" : "none" }}
            >
                <Accordion expanded={this.state.expanded} className={this.getSectionClasses()}>
                    <AccordionSummary
                        ref={(summary) => (this.summaryRef = summary)}
                        className={this.getClasses()}
                        classes={{ content: classes.AccordionSummaryContent.content }}
                    >
                        <div className="col-lg-10 col-md-10 col-sm-10 col-10 row without-side-padding without-margin">
                            <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-2">
                                {expandedElement}
                            </div>
                            <div
                                className="col-lg-10 col-md-10 col-sm-10 col-10 without-side-padding"
                                onClick={this.onSectionHeaderClick.bind(this)}
                            >
                                <Typography className={classes.heading}>{section.title}</Typography>
                            </div>
                            {this.props.currentSectionId === this.props.expandedSectionId ? (
                                <div className="without-side-padding offset-lg-2 col-lg-10 offset-md-2 col-md-10 offset-sm-2 col-sm-10 offset-2 col-10">
                                    <div
                                        className={classes.italic}
                                        dangerouslySetInnerHTML={{ __html: section.note }}
                                    />
                                </div>
                            ) : null}
                        </div>
                        {this.props.currentSectionId === this.props.expandedSectionId &&
                        canUpdateForm(this.props.currentInterview, this.props.activeUser) ? (
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 without-side-padding">
                                <Fab
                                    size="small"
                                    onClick={this.saveSection.bind(this, this.props.currentSectionId)}
                                    color="secondary"
                                    className="div-center"
                                >
                                    <Icon>save</Icon>
                                </Fab>
                            </div>
                        ) : sectionRead(section) ? (
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 without-side-padding center-content">
                                <Icon color="primary">visibility</Icon>
                            </div>
                        ) : null}
                    </AccordionSummary>
                    <AccordionDetails className="form-panel-details">
                        <div className="form-section">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">{questionsElements}</div>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sections: state.form.formSections,
        form: state.form.currentForm,
        activeUser: state.activeUser,
        expandedSectionId: state.form.currentSectionId,
        currentInterview: state.form.currentInterview,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
        saveQuestions: (form, sections, questions, user) => dispatch(saveQuestions(form, sections, questions, user)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(FormSection);
